import type { GetZoisStore } from '$houdini';
import type { ItineraryResultsStore } from '$lib/components/itinerary/types';
import type { Zoi } from '$lib/components/zoi/types';
import type { SearchParams } from '$lib/services/urls/searchParams';
import type { AugmentedHoudiniStore } from '$lib/utils/augmentedHoudiniStore';
import { browser } from '$app/environment';
import { derived, get } from 'svelte/store';

export function loadZois(
	searchZoisStore: AugmentedHoudiniStore<GetZoisStore>,
	itineraryResultsStore: ItineraryResultsStore,
) {
	return derived([searchZoisStore, itineraryResultsStore], ([$zois, $itineraryResult]) => {
		const zois: Zoi[] = [];

		const fetchedZois = $zois?.data?.getZois?.zoiList;
		if (fetchedZois) {
			zois.push(...fetchedZois);
		}

		const arrivalZoi = $itineraryResult.arrivalZoi;
		if (arrivalZoi) {
			zois.push({ ...arrivalZoi, isArrivalZoi: true });
		}

		return { zois, errors: arrivalZoi ? null : $zois.errors, fetching: $zois.fetching };
	});
}

export async function fetchZois(
	searchZoisStore: AugmentedHoudiniStore<GetZoisStore>,
	itineraryResultsStore: ItineraryResultsStore,
	searchParams: SearchParams,
): Promise<void> {
	if (browser) {
		const {
			selectedRoute,
		} = searchParams;

		itineraryResultsStore.lastFetchPromise().then(async () => {
			const routeEncodedGeometry
			= get(itineraryResultsStore).routes[selectedRoute ?? 0].encodedGeometry;

			if (!routeEncodedGeometry) {
				return;
			}

			await searchZoisStore.fetch({
				blocking: true,
				variables: {
					input: {
						routeGeometry: routeEncodedGeometry,
						containsEvOnly: searchParams.zoiSettings?.containsEvOnly,
						distance: searchParams.zoiSettings?.distance,
					},
				},
			});
		});
	}
}
